import { useApp } from 'store/steps'
import { useAppSelector } from 'store/hooks'
import {
    mergeCardsWithPromotions,
    mergeTickets,
    mergeTicketsBundles,
    sumTicketsBundlesDates,
    sumTicketsDates,
} from 'components/global/Summary/helpers'
import { useMemo } from 'react'

export const useDiscountedProducts = () => {
    const { language, appMode } = useApp()

    const { items } = useAppSelector((state) => state.cart)
    const { items: selfcareItems } = useAppSelector(
        (state) => state.selfcareCart
    )

    const isSelfcare = appMode === 'selfcare'

    const {
        spa,
        tickets,
        ticketsBundles,
        busTickets,
        cabanas,
        cards,
        accommodation,
    } = isSelfcare
        ? { ...selfcareItems, spa: [], cards: [], accommodation: null }
        : items

    const discountedTickets = useMemo(
        () => mergeTickets(tickets).filter((ticket) => ticket.hasPromotion),
        [tickets]
    )
    const hasDiscountedTickets = !!discountedTickets.length

    const discountedTicketsBundles = useMemo(
        () =>
            mergeTicketsBundles({ ticketsBundles, language }).filter(
                (ticketBundle) => ticketBundle.hasPromotion
            ),
        [ticketsBundles, language]
    )
    const hasDiscountedTicketsBundles = !!discountedTicketsBundles.length

    const discountedTicketDates = hasDiscountedTickets
        ? sumTicketsDates(tickets)
        : sumTicketsBundlesDates(ticketsBundles)

    const discountedSpa = useMemo(
        () => spa.filter((spa) => spa.hasPromotion),
        [spa]
    )
    const hasDiscountedSpa = !!discountedSpa.length

    const discountedBusTickets = useMemo(
        () => busTickets.filter((busTicket) => busTicket.hasPromotion),
        [busTickets]
    )
    const hasDiscountedBusTickets = !!discountedBusTickets.length

    const discountedCabanas = useMemo(
        () => cabanas.filter((cabana) => cabana.hasPromotion),
        [cabanas]
    )
    const hasDiscountedCabanas = !!discountedCabanas.length

    const discountedCards = useMemo(
        () =>
            mergeCardsWithPromotions(cards).filter((card) => card.hasPromotion),
        [cards]
    )
    const hasDiscountedCards = !!discountedCards.length

    const hasDiscountedAccommodation =
        accommodation && accommodation.hasPromotion

    const hasDiscountedProducts = !!(
        hasDiscountedTickets ||
        hasDiscountedTicketsBundles ||
        hasDiscountedSpa ||
        hasDiscountedBusTickets ||
        hasDiscountedCabanas ||
        hasDiscountedCards ||
        hasDiscountedAccommodation
    )

    return {
        hasDiscountedProducts,
        hasDiscountedTickets,
        hasDiscountedTicketsBundles,
        hasDiscountedSpa,
        hasDiscountedBusTickets,
        hasDiscountedCabanas,
        hasDiscountedCards,
        hasDiscountedAccommodation,
        discountedTickets,
        discountedTicketsBundles,
        discountedSpa,
        discountedBusTickets,
        discountedCabanas,
        discountedCards,
        discountedTicketDates,
    }
}
